import React, { Fragment } from 'react'
import styled from 'styled-components'
import { Link, useLocation } from 'react-router-dom'

import {
  Container,
  Title,
  CustomSubtitle,
  ContainerFlexColumn,
  Input,
  ActionButtons,
} from './Utils/CustomClasses'

import { textTranslation, shouldTranslateTo } from '../utils/utils'

// import { Container } from './styles';

const Header = styled.div`
  background-color: #f2e8d8;
  padding-top: 50px;

  background-image: url(${(props) => props.image});
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center top;

  @media screen and (max-width: 768px) {
    background-size: contain;
  }
`

const GiftButton = styled(ActionButtons)`
  margin-top: 30px;
  ${(props) => props.fullWidth && `width: -webkit-fill-available`};
  justify-content: center;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available;
    padding: 15px 10px;
  }
`

const GiftImage = styled.div`
  height: 380px;
  width: 100%;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;

  @media screen and (max-width: 768px) {
    height: 220px;
  }
`

const BkContainerFlexColumn = styled(ContainerFlexColumn)`
  background-image: url(${(props) => props.image});
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center top;

  @media screen and (max-width: 768px) {
    background-size: contain;
  }
`

const Form = styled.form`
  text-align: left;
  width: 40vw;
  min-width: 400px;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available !important;
    min-width: unset !important;
  }
`

const CongratulationsPage = ({ pageText }) => {
  localStorage.clear()
  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <div>
      <Header
      /*
                image={
                    window.innerWidth < 768
                        ? "/images/gift/snowflakes1-mobile.svg"
                        : "/images/gift/snowflakes1.svg"
                }
                */
      >
        <Title
          center
          smCenter
          size="30px"
          sizemd="25px"
          sizesm="22px"
          margin="0 0 40px 0"
          paddingSm="0 18px"
          dangerouslySetInnerHTML={{ __html: `${pageText[0]}` }}
        />
        <GiftImage image="/images/gift/gift.svg" />
      </Header>
      <BkContainerFlexColumn
        /*
                image={
                    window.innerWidth < 768
                        ? "/images/gift/snowflakes2-mobile.svg"
                        : "/images/gift/snowflakes2.svg"
                }
                */
        center
        background="#fff"
        padding="5px 0 150px 0"
        paddingSm="10px 5vw 100px 5vw"
      >
        <CustomSubtitle
          bold
          center
          size="24px"
          margin="0 0 40px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[1]}`,
          }}
        />
        <CustomSubtitle
          center
          size="22px"
          margin="0 0 40px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[2]}`,
          }}
        />
        <CustomSubtitle
          center
          size="22px"
          margin="0 0 60px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[3]}`,
          }}
        />
        {/*
                <GiftButton
                    padding="15px 70px"
                    type="submit"
                    onClick={(e) => console.log}
                >
                    {pageText[4]}{" "}
                    <img src="/images/icons/download.svg" alt="download" />
                </GiftButton>
                */}
      </BkContainerFlexColumn>
    </div>
  )
}

const WelcomePage = ({ activationCode, pageText }) => {
  const [userName, setUserName] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [passwordConfirmation, setPasswordConfirmation] = React.useState('')
  const [emailError, setEmailError] = React.useState(false)
  const [activationCodeError, setActivationCodeError] = React.useState(false)
  const [passwordError, setPasswordError] = React.useState(false)
  const [error, setError] = React.useState(false)
  const [errorText, setErrorText] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [showCode, setShowCode] = React.useState(false)
  const [showPassword, setShowPassword] = React.useState(false)

  const auth = props.auth
  const { history } = props

  if (activationCode == '') {
    setShowCode(true)
  }

  // If the user is authenticated, we're sending him back to the Login Page
  if (auth.user === null || auth.user.id === '') {
    VerifyActivationCode(activationCode)
  } else {
    history.push('/dashboard')
  }

  const updateEmail = (e) => {
    setEmailError(false)
    setError(false)
    setEmail(e)
  }

  const updateActivationCode = (e) => {
    setActivationCodeError(false)
    setError(false)
    setActivationCode(e)
  }

  const updatePassword = (e) => {
    setPasswordError(false)
    setError(false)
    setPassword(e)
  }

  const updatePasswordConfirmation = (e) => {
    setPasswordError(false)
    setError(false)
    setPasswordConfirmation(e)
  }

  const VerifyActivationCode = (activationCode) => {
    if (activationCode !== '') {
      axios
        .post('/api/gift/code/verify', { code: activationCode })
        .then((response) => {
          if (response.data.userForename === '') {
            history.push('/loginsignup')
          } else {
            setUserName(response.data.userForename)
          }
        })
        .catch((err) => {
          setErrorText(err)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  const HandleGiftActivation = (e) => {
    e.preventDefault()
    console.log('e: ' + e)

    if (!activationCode) {
      setError(true)
      setActivationError(true)
      setErrorText(pageText[12])
      return
    }

    if (!isValidEmail(email)) {
      setError(true)
      setEmailError(true)
      setErrorText(pageText[13])
      return
    }

    if (showPassword) {
      if (password !== passwordConfirmation) {
        setError(true)
        setPasswordError(true)
        setErrorText(pageText[14])
        return
      }
    }

    setLoading(true)

    const data = {
      email: email,
      code: activationCode,
    }

    if (showPassword) {
      data.password = password
      data.password_confirmation = passwordConfirmation

      axios
        .post('/api/gift/activate', data)
        .then((response) => {
          auth.handleLogin(response.data.user)
          history.push('/dashboard')
        })
        .catch((err) => {
          setError(true)
          setErrorText(err)
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      axios
        .post('/api/gift/verify', data)
        .then((response) => {
          if (response.data.success === false) {
            setLoading(false)
            setValid(false)
            setError(true)
            setErrorText(pageText[15])
          } else {
            setShowPassword(true)
          }
        })
        .catch((err) => {
          setError(true)
          setErrorText(err)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <div>
      {loading && <Spinner />}
      <Header
        image={
          window.innerWidth < 768
            ? '/images/gift/snowflakes1-mobile.svg'
            : '/images/gift/snowflakes1.svg'
        }
      >
        <Title
          center
          smCenter
          size="70px"
          sizemd="25px"
          sizesm="22px"
          margin="0 0 40px 0"
          paddingSm="0 18px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[0] + '<b><i> ' + userName + '</i></b>'}`,
          }}
        />
        <Title
          center
          smCenter
          size="30px"
          sizemd="25px"
          sizesm="22px"
          margin="0 0 40px 0"
          paddingSm="0 18px"
          dangerouslySetInnerHTML={{ __html: `${pageText[1]}` }}
        />
        <GiftImage image="/images/gift/gift.svg" />
      </Header>
      <BkContainerFlexColumn
        center
        padding="10px 0 80px 0"
        paddingSm="30px 4vw"
        background="#fff"
        image={
          window.innerWidth < 768
            ? '/images/gift/snowflakes2-mobile.svg'
            : '/images/gift/snowflakes2.svg'
        }
      >
        <CustomSubtitle
          center
          size="22px"
          sizemd="22px"
          sizesm="17px"
          margin="0 0 40px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[2]}`,
          }}
        />
        <Form onSubmit={(e) => HandleGiftActivation(e)}>
          {/* Email */}
          <CustomSubtitle
            bold
            size="18px"
            margin="0 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[3]}`,
            }}
          />
          <Input
            id="email"
            type="email"
            name="email"
            className={emailError && 'error-border'}
            placeholder={pageText[4]}
            required
            autoFocus
            value={email}
            onChange={(e) => updateEmail(e.target.value)}
          />
          {/* Code */}
          <CustomSubtitle
            bold
            size="18px"
            margin="0 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[5]}`,
            }}
          />
          <Input
            id="activationCode"
            type="text"
            name="activationCode"
            className={activationCodeError && 'error-border'}
            placeholder={pageText[6]}
            readOnly={!showCode}
            required
            autoFocus
            value={password}
            onChange={(e) => updateActivationCode(e.target.value)}
          />
          {showPassword ? (
            <Fragment>
              <Title
                center
                smCenter
                size="30px"
                sizemd="25px"
                sizesm="22px"
                margin="0 0 40px 0"
                paddingSm="0 18px"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[10] + activationCode}`,
                }}
              />
              {/* Password */}
              <CustomSubtitle
                bold
                size="18px"
                margin="0 0 11px 0px"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[7]}`,
                }}
              />
              <Input
                id="password"
                type="password"
                name="password"
                className={passwordError && 'error-border'}
                placeholder={pageText[8]}
                required
                autoFocus
                value={password}
                onChange={(e) => updatePassword(e.target.value)}
              />
              {/* Confirm Password */}
              <CustomSubtitle
                bold
                size="18px"
                margin="0 0 11px 0px"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[9]}`,
                }}
              />
              <Input
                id="passwordConfirmation"
                type="password"
                name="passwordConfirmation"
                className={passwordError && 'error-border'}
                placeholder={pageText[10]}
                required
                autoFocus
                value={passwordConfirmation}
                onChange={(e) => updatePasswordConfirmation(e.target.value)}
              />
            </Fragment>
          ) : (
            <Fragment>
              {error && <Error error={errorText} />}

              <GiftButton
                fullWidth
                padding="12px 14px"
                type="submit"
                onClick={(e) => HandleGiftActivation(e)}
              >
                {pageText[11]}
              </GiftButton>
            </Fragment>
          )}
        </Form>
      </BkContainerFlexColumn>
    </div>
  )
}

function GiftYourWelcomeCongrats() {
  const location = useLocation()
  const [isWelcomePage, setIsWelcomePage] = React.useState(false)
  const [pageTextWelcome, setPageTextWelcome] = React.useState([])
  const [pageTextCongrats, setPageTextCongrats] = React.useState([])
  const [activationCode, setActivationCode] = React.useState('')

  React.useEffect(() => {
    setIsWelcomePage(location.pathname.includes('welcome'))

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    if (location.pathname.includes('welcome')) {
      setActivationCode(location.search.get('code'))
      getPageText('welcome-gift', language, setPageTextWelcome)
    } else {
      getPageText('congrats-gift', language, setPageTextCongrats)
    }
  }, [location.pathname])

  return (
    <Container>
      {isWelcomePage ? (
        <WelcomePage
          pageText={pageTextWelcome}
          activationCode={activationCode}
        />
      ) : (
        <CongratulationsPage pageText={pageTextCongrats} />
      )}
    </Container>
  )
}

export default GiftYourWelcomeCongrats
